// extracted by mini-css-extract-plugin
module.exports =  {"gridLinesGroup":"HorizontalGridLines-module__gridLinesGroup--GGcCS","yAxisLabel":"HorizontalGridLines-module__yAxisLabel--CJe1L"};